import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Asset from "./Asset";
import { setloading } from "../../redux/sceneSlice";
import { reduxLocalStorage } from "../utility/storage";
function Ceilings(props) {
  const project_id = reduxLocalStorage.getItem("project_id");
  var ceilingList = useSelector((state) => state.sceneVar.ceilingList);
  const dispatch = useDispatch();
  const selectedFloor = useSelector(
    (state) => state.floorVisibility.selectedFloors,
  );
  var targetBuildingScene = useSelector(
    (state) => state.sceneVisibility.value[3],
  );

  return (
    <group name="ceiling" visible={targetBuildingScene}>
      {ceilingList.map((floor, index) => {
        return (
          <React.Fragment key={index}>
            <Asset
              url={`${process.env.REACT_APP_API_URL}project/glb/?project_id=${project_id}&type=${floor}`}
              visible={selectedFloor[index]}
              onFulfilled={() =>
                dispatch(
                  setloading({ index: 3, subIndex: index, value: false }),
                )
              }
              onLoading={() =>
                dispatch(setloading({ index: 3, subIndex: index, value: true }))
              }
            />
          </React.Fragment>
        );
      })}
    </group>
  );
}
export default React.memo(Ceilings);
